import { useEffect, useState } from 'react';

export type Theme =
  | 'kalba_light'
  | 'kalba_dark'
  | 'shj_light'
  | 'shj_dark'
  | 'ds_light'
  | 'ds_dark'
  | 'beeah_corp_light'
  | 'beeah_corp_dark'
  | 'beeah_light'
  | 'beeah_dark'
  | 'kalba_new_shj_light'
  | 'kalba_new_shj_dark';

const ALL_THEMES: Theme[] = [
  'kalba_light',
  'kalba_dark',
  'shj_light',
  'shj_dark',
  'ds_light',
  'ds_dark',
  'beeah_corp_light',
  'beeah_corp_dark',
  'beeah_light',
  'beeah_dark',
  'kalba_new_shj_light',
  'kalba_new_shj_dark',
];

const THEME_CLASSES: Record<Theme, string[]> = {
  kalba_light: ['kalba-light'],
  kalba_dark: ['kalba-dark', 'dark'],
  shj_light: ['shj-light'],
  shj_dark: ['shj-dark', 'dark'],
  ds_light: ['ds-light'],
  ds_dark: ['ds-dark', 'dark'],
  beeah_corp_light: ['beeah-corp-light'],
  beeah_corp_dark: ['beeah-corp-dark', 'dark'],
  beeah_light: ['beeah-light'],
  beeah_dark: ['beeah-dark', 'dark'],
  kalba_new_shj_light: ['kalba-new-shj-light'],
  kalba_new_shj_dark: ['kalba-new-shj-dark', 'dark'],
};

function getInitial(): Theme {
  try {
    const stored = localStorage.getItem('theme') as Theme | null;
    if (stored && (ALL_THEMES as string[]).includes(stored)) return stored;
    const legacy = localStorage.getItem('darkMode');
    if (legacy !== null) return legacy === 'true' ? 'kalba_dark' : 'kalba_light';
    return 'kalba_light';
  } catch {
    return 'kalba_light';
  }
}

export function useTheme() {
  const [theme, setThemeState] = useState<Theme>(getInitial);

  useEffect(() => {
    const root = document.documentElement;
    root.classList.remove(
      'dark',
      'kalba-light',
      'kalba-dark',
      'shj-light',
      'shj-dark',
      'ds-light',
      'ds-dark',
      'beeah-corp-light',
      'beeah-corp-dark',
      'beeah-light',
      'beeah-dark',
      'kalba-new-shj-light',
      'kalba-new-shj-dark',
    );
    for (const cls of THEME_CLASSES[theme]) {
      root.classList.add(cls);
    }
    try {
      localStorage.setItem('theme', theme);
    } catch {
      // ignore
    }
  }, [theme]);

  const setTheme = (t: Theme) => setThemeState(t);

  return { theme, setTheme };
}
